import { images } from '_/assets';
import Text from '_/components/Text';
import { colors } from '_/config/theme';
import { hp, wp } from '_/helpers/dimension';
import React from 'react';
import { View, StyleSheet, Image, ActivityIndicator, StyleProp, ViewStyle } from 'react-native';

interface LoadingViewProps {
  title?: string;
  subtitle?: string;
  backgroundColor?: string;
  textColor?: string;
  activityIndicatorColor?: string;
  containerStyle?: StyleProp<ViewStyle>;
}

const LoadingView: React.FC<LoadingViewProps> = ({
  title,
  subtitle,
  backgroundColor = colors.primary,
  textColor = colors.white,
  activityIndicatorColor = colors.white,
  containerStyle,
}) => {
  return (
    <View style={[styles.container, { backgroundColor }, containerStyle]}>
      <View style={[styles.innerContainer, { flex: 2 }]}>
        <Image source={images.icon} style={styles.image} resizeMode="contain" />
        {title && (
          <Text fontType="semibold" center size={38} color={textColor} style={styles.title}>
            {title}
          </Text>
        )}
        {subtitle && (
          <Text center size={20} color={textColor}>
            {subtitle}
          </Text>
        )}
      </View>
      <View style={styles.innerContainer}>
        <ActivityIndicator color={activityIndicatorColor} size="large" />
      </View>
    </View>
  );
};

export default LoadingView;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  innerContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    width: wp(300),
    height: hp(300),
  },
  title: {
    marginTop: hp(8),
  },
});
